import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss']
})
export class AttachmentsComponent implements OnInit {
  ngOnInit(): void {
    this.data.attachments_attachments =  Array.isArray(this.data.attachments_attachments) ? this.data.attachments_attachments.filter((attachment: any) => attachment.status === true ) : [];
  }
  @Input() data: any;
}
